/**
 * DebugRoot (009) — mounted once in the app tree. Renders the debug overlay only
 * when debug is enabled; otherwise renders nothing (zero footprint).
 */
import { isDebugEnabled } from './flag.js'
import { DebugPanel } from './DebugPanel.js'

export function DebugRoot() {
  if (!isDebugEnabled()) return null
  return <DebugPanel />
}
